import { render, staticRenderFns } from "./EmptyNevronHeader.vue?vue&type=template&id=8d99b902&"
import script from "./EmptyNevronHeader.vue?vue&type=script&lang=ts&"
export * from "./EmptyNevronHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports